"use client";
import { createContext, useContext, useMemo, useState } from "react";

const StoreContext = createContext<any>(undefined);
export const useStore = () => {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error("useStore must be used within a StoreProvider");
  }
  return context;
};

export const StoreProvider = ({ children }: any) => {
  const [filter, setFilter] = useState({
    type: "buy",
    propertyType: [],
    location: [],
    priceOrder: "",
  });

  const [termsTab, setTermsTab] = useState<number | null>(null);

  const value = useMemo(
    () => ({
      filter,
      setFilter,
      termsTab,
      setTermsTab,
    }),
    [filter, termsTab],
  );

  return (
    <StoreContext.Provider value={value}>{children}</StoreContext.Provider>
  );
};
